<template>
	<div class="flex w-full justify-center" :class="{ 'px-4': !section.fullWidth }">
		<component :is="tag" v-bind="linkAttrs" class="block w-full" :class="{ 'max-w-8xl': !section.fullWidth }">
			<picture>
				<source v-if="section.mobileImage" media="(max-width: 767px)" :srcset="section.mobileImage" />
				<img :src="section.image" :alt="section.alt || ''" class="block w-full h-auto" :class="{ 'rounded-lg': !section.fullWidth }" loading="lazy" />
			</picture>
		</component>
	</div>
</template>

<script>
// A banner image an admin added on Storefront › Home page, with an optional
// phone version and link.
export default {
	props: {
		section: { type: Object, required: true },
	},
	computed: {
		tag() {
			if (!this.section.link) return 'div'
			return this.section.link.startsWith('/') && !this.section.newTab ? 'router-link' : 'a'
		},
		linkAttrs() {
			const link = this.section.link
			if (!link) return {}
			if (this.tag === 'router-link') return { to: link }
			return this.section.newTab ? { href: link, target: '_blank', rel: 'noopener noreferrer' } : { href: link }
		},
	},
}
</script>
